module.exports = __webpack_public_path__ + "static/media/up.58e55638.svg";